import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getStatus } from '@utils';
import { useNotifications, useLocation, useNavigate } from '@utils/hooks';
import { descriptorMask } from '@utils/mask';
import { LocationStateType } from '@utils/types';

import { buyActions, useStore } from '@modules';

import InputMask from '@components/InputMask';
import MainLayout from '@layouts/MainLayout';

import style from './VerifyDescriptor.scss';

const cn = bemCssModules(style, 'VerifyDescriptor');

const PREFIX = 'M-';

const VerifyDescriptor: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [{ buy }, dispatch] = useStore();
  const navigate = useNavigate();
  const { buySuccessNotification, buyErrorNotification } = useNotifications();

  const location = useLocation<LocationStateType['descriptor']>();
  const { state } = location;

  const handleSubmit = (value: string) => {
    const id = state?.id;

    if (id) {
      const data = { id, code: value.slice(PREFIX.length) };
      dispatch(buyActions.getBuyVerificationDescriptor(data))
        .unwrap()
        .then(res => {
          const { isFailed, isSucceeded } = getStatus(res.data.status);
          const { amount, currency } = state;
          const url = state.currency ? `${CONST.nav.wallets}/${state.currency}` : CONST.nav.wallets;
          const totalWithCurrency = amount ? `${amount} ${currency}` : currency;

          if (isSucceeded) buySuccessNotification(totalWithCurrency);
          if (isFailed) buyErrorNotification();

          navigate(url);
        });
    }
  };

  const handleChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    setCode(inputValue);

    if (inputValue.length === descriptorMask.mask.length) handleSubmit(inputValue);
  };

  const helpText = t('descriptor.help_text');
  const isLoading = !!buy.loaders.getBuyVerificationDescriptor;

  const onBack = () => navigate(CONST.nav.topup);

  return (
    <MainLayout backButton={onBack}>
      <div className={cn(null, [className])}>
        <h1>{t('descriptor.h1')}</h1>
        <p className={cn('text')}>{t('descriptor.sub_title')}</p>

        <InputMask
          maskOptions={descriptorMask}
          className={cn('input')}
          placeholder="M-12345"
          id="code"
          value={code}
          onChange={handleChangeCode}
          isLoading={isLoading}
          autoComplete="off"
          inputMode="decimal"
          tooltipContent={helpText}
          autoFocus
        />

        <p className={cn('help-text', ['text-base'])}>{helpText}</p>

        <div className={cn('example')}>
          <small>Mercuryo M-12345</small>
          <small>-XX EUR</small>
        </div>
      </div>
    </MainLayout>
  );
};

export default VerifyDescriptor;
